import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import TeamMembersManagerV2 from './TeamMembersManagerV2';

const TeamMembersDemo = () => {
  const { currentUser } = useAuth();
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    if (currentUser) {
      setUserId(currentUser.uid);
    }
  }, [currentUser]);

  if (!userId) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-blue-600"></div>
          <p className="text-slate-600">Loading user data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8">
          <h1 className="mb-2 text-3xl font-bold text-slate-900">Team Members Management</h1>
          <p className="text-slate-600">Manage your team members with full CRUD operations</p>
        </div>

        <TeamMembersManagerV2 userId={userId} isReadOnly={false} />
      </div>
    </div>
  );
};

export default TeamMembersDemo;
